import { d as c, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as t, normalizeClass as l, normalizeStyle as n, createElementVNode as r } from "vue";
const a = c("jdl"), m = /* @__PURE__ */ r("path", {
  d: "M964.923 1024c-98.461 0-181.17-66.954-208.738-157.538H543.508C515.938 957.046 433.23 1024 334.769 1024s-185.107-66.954-208.738-161.477C59.077 846.77 7.877 787.693 0 716.8V448.985c0-27.57 11.815-51.2 27.57-70.893l153.6-153.6c15.753-15.754 39.384-23.63 63.015-23.63h70.892v-15.754C315.077 82.708 401.723 0 504.123 0h405.662c149.661 0 271.753 122.092 271.753 271.754v535.63c0 118.154-98.461 216.616-216.615 216.616zM496.246 748.308h307.2c35.446 0 63.016 27.569 63.016 59.077v7.877c3.938 47.261 47.261 86.646 98.461 86.646 55.139 0 98.462-43.323 98.462-98.462V271.754c0-82.708-70.893-153.6-153.6-153.6H504.123c-39.385 0-66.954 31.508-66.954 66.954v59.077c0 39.384-31.507 70.892-74.83 70.892h-102.4L118.153 456.862v256c0 19.692 19.692 35.446 39.384 35.446h11.816c35.446 0 63.015 27.569 63.015 59.077V819.2c11.816 51.2 51.2 86.646 102.4 86.646s90.585-35.446 98.462-82.708V819.2c0-43.323 27.569-70.892 63.015-70.892zm-378.092 66.954zm129.97-496.247zm19.691-7.877zm47.262-66.953zm43.323-43.323zm15.754 271.753c-31.508 0-59.077-27.569-59.077-59.077V256c0-31.508 27.57-59.077 59.077-59.077S433.23 224.493 433.23 256v157.538c0 31.508-27.57 59.077-59.077 59.077z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), i = [
  m
];
function p(e, d, _, f, h, v) {
  return s(), t("svg", {
    class: l(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1181 1024",
    role: "presentation"
  }, i, 6);
}
const C = /* @__PURE__ */ o(a, [["render", p]]);
export {
  C as default
};
